import { MiddlewareReturn, MiddlewareState } from '@floating-ui/dom';

const transformOriginVerticalPosition = {
  top: 'bottom',
  bottom: 'top',
};

const transformOriginHorizontalPosition = {
  left: 'right',
  right: 'left',
};

const transformOriginHorizontalAlignment = {
  center: 'center',
  start: 'top',
  end: 'bottom',
};

const transformOriginVerticalAlignment = {
  center: 'center',
  start: 'left',
  end: 'right',
};

function computeOriginDirection(originalPlacement: string): string {
  const [position, alignment] = originalPlacement.split('-');
  const xPosition = transformOriginHorizontalPosition[position] ?? transformOriginVerticalAlignment[alignment] ?? 'center';
  const yPosition = transformOriginVerticalPosition[position] ?? transformOriginHorizontalAlignment[alignment] ?? 'center';

  return `${xPosition} ${yPosition}`;
}

export function transformOrigin() {
  return {
    name: 'transform-origin',
    fn({ placement, elements }: MiddlewareState): MiddlewareReturn {
      Object.assign(elements.floating.style, {
        transformOrigin: computeOriginDirection(placement),
      });

      return {
        data: {
          transformOrigin: computeOriginDirection(placement),
        },
      };
    }
  };
}
